<template>
    <div class="wrapper">
        <section>
            <h4>Account</h4>
            <div class="row">
                <custom-input name="accountBackgroundColor" ref="accountBackgroundColor" label="Background color" type="colorpicker" v-model="settings.accountBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The background color of the balloon containing a message that the account sends back</p>
                    </template>
                </help-popover>

                <custom-input name="accountTextColor" ref="accountTextColor" label="Text color" type="colorpicker" v-model="settings.accountTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the message that the account sends back</p>
                    </template>
                </help-popover>
            </div>
            <div class="row">
                <custom-input name="accountTimeColor" ref="accountTimeColor" label="Time color" type="colorpicker" v-model="settings.accountTimeColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the time shown in the balloon of a message from the account</p>
                    </template>
                </help-popover>
            </div>
            <div class="row">
                <custom-input name="accountTextLinkColor" ref="accountTextLinkColor" label="Account text link color" type="colorpicker" v-model="settings.accountTextLinkColor" />
                <help-popover>
                    <template slot="content">
                        <p>A linked that is shared by the account will be this color to indicate that you can click on it</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>User</h4>
            <div class="row">
                <custom-input name="userBackgroundColor" ref="userBackgroundColor" label="Background color" type="colorpicker" v-model="settings.userBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The background color of the balloon containing the users messages</p>
                    </template>
                </help-popover>

                <custom-input name="userTextColor" ref="userTextColor" label="Text Color" type="colorpicker" v-model="settings.userTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the message on that balloon</p>
                    </template>
                </help-popover>
            </div>
            <div class="row">
                <custom-input name="userTimeColor" ref="userTimeColor" label="Time Color" type="colorpicker" v-model="settings.userTimeColor" />
                <help-popover>
                    <template slot="content">
                        <p>The time indicator in a users message will get this color</p>
                    </template>
                </help-popover>
            </div>
            <div class="row">
                <custom-input name="userTextLinkColor" ref="userTextLinkColor" label="User text link Color" type="colorpicker" v-model="settings.userTextLinkColor" />
                <help-popover>
                    <template slot="content">
                        <p>When the user sends a link, this is the color it will appear in</p>
                    </template>
                </help-popover>

                <custom-input name="userSentColor" ref="userSentColor" label="User sent Color" type="colorpicker" v-model="settings.userSentColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the checkmark that a message of the user is successfully send</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Background</h4>
            <div class="row">
                <custom-input name="backgroundColor" ref="backgroundColor" label="Color" type="colorpicker" v-model="settings.backgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The main background color, behind the messages from the user and account</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Button</h4>
            <div class="row">
                <custom-input name="buttonLabelBackgroundColor" ref="buttonLabelBackgroundColor" label="Label background color" type="colorpicker" v-model="settings.buttonLabelBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>Defines the background color for the label of the opening icon (web only)</p>
                        <br>
                        <small style="color:red">NOT YEST SUPPORTED IN WEB LIBRARY</small>
                    </template>
                </help-popover>

                <custom-input name="buttonLabelTextColor" ref="buttonLabelTextColor" label="Button label text color" type="colorpicker" v-model="settings.buttonLabelTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The text color the label of the opening icon (web only)</p>
                        <br>
                        <small style="color:red">NOT YEST SUPPORTED IN WEB LIBRARY</small>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Date</h4>
            <div class="row">
                <custom-input name="dateColor" ref="dateColor" label="Color" type="colorpicker" v-model="settings.dateColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the date text and border</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Info</h4>
            <div class="row">
                <custom-input name="infoTextColor" ref="infoTextColor" label="Text color" type="colorpicker" v-model="settings.infoTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the info messages that are shown before or between message balloons</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Messenger</h4>
            <div class="row">
                <custom-input name="messengerIconBackgroundColor" ref="messengerIconBackgroundColor" label="Icon background color" type="colorpicker" v-model="settings.messengerIconBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The background color for the icon for opening the chat (web only)</p>
                        <br>
                        <small style="color:red">NOT YEST SUPPORTED IN WEB LIBRARY</small>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Nav</h4>
            <div class="row">
                <custom-input name="navBackgroundColor" ref="navBackgroundColor" label="Background color" type="colorpicker" v-model="settings.navBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The background color of the main navigation</p>
                    </template>
                </help-popover>

                <custom-input name="navTextColor" ref="navTextColor" label="Text Color" type="colorpicker" v-model="settings.navTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the text and icons used on the main navigation</p>
                    </template>
                </help-popover>
            </div>
        </section>

        <section>
            <h4>Input</h4>
            <div class="row">
                <custom-input name="inputFieldBackgroundColor" ref="inputFieldBackgroundColor" label="Input field background color" type="colorpicker" v-model="settings.inputFieldBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>Defines the background color for the input field the user will type their response in</p>
                    </template>
                </help-popover>

                <custom-input name="inputFieldTextColor" ref="inputFieldTextColor" label="Input field text color" type="colorpicker" v-model="settings.inputFieldTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the text that the user will type in that field</p>
                    </template>
                </help-popover>

                <custom-input name="inputFieldPlaceHolderColor" ref="inputFieldPlaceHolderColor" label="Input field Placeholder text color" type="colorpicker" v-model="settings.inputFieldPlaceHolderColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of the placeholder text in the input field. This is usually a lighter color than the actual text color</p>
                    </template>
                </help-popover>
            </div>
            <div class="row">
                <custom-input name="inputBackgroundColor" ref="inputBackgroundColor" label="Input background color" type="colorpicker" v-model="settings.inputBackgroundColor" />
                <help-popover>
                    <template slot="content">
                        <p>The background color behind the input element</p>
                    </template>
                </help-popover>

                <custom-input name="inputTextColor" ref="inputTextColor" label="Input text color" type="colorpicker" v-model="settings.inputTextColor" />
                <help-popover>
                    <template slot="content">
                        <p>The color of icons or text on the above mentioned background color</p>
                    </template>
                </help-popover>
            </div>
        </section>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput.vue';
import HelpPopover from '../../additional/helpPopover';

export default {
    name: 'appearanceGeneral',
    mixins: [
        Default
    ],
    props: ['settings'],
    components: {
        HelpPopover,
        customInput
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
